import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import AppLogo from "../../assets/images/logo.svg";
import LayoutLogo from "../../assets/images/topDesign.svg";
import "../../App.css";
import { useNavigate } from "react-router-dom";
import LeftSideImage from "../../commonUses/leftSideImage";
import PasswordArea from "../../components/passwordField";
import LockIcon from "../../assets/images/lockIcon.svg";
import { passwordChangeApi } from "../../api/adminApi";
import { StyledSubmitButton } from "../../StyledComponents/StyledComponents";
export default function PasswordChangePage() {
  const isVerified = sessionStorage.getItem("isVerified");
  const navigate = useNavigate();
  useEffect(() => {
    if (
      emailFromSession == null ||
      isVerified === "false" ||
      isVerified === null
    ) {
      navigate("/sendOtp");
    }
  }, []);

  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [newPasswordError, setNewPasswordError] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState("");

  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const emailFromSession = sessionStorage.getItem("Email");

  const handleNewPasswordChange = (e) => {
    const inputValue = e.target.value;
    setNewPassword(inputValue);
    setNewPasswordError("");
  };

  const handleConfirmPasswordChange = (e) => {
    const inputValue = e.target.value;
    setConfirmPassword(inputValue);
    setConfirmPasswordError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const email = sessionStorage.getItem("Email");
    
    let hasError = false;

    if (newPassword.length === 0) {
      setNewPasswordError("*Please Enter New Password");
      hasError = true;
    }
    
    if (confirmPassword.length === 0) {
      setConfirmPasswordError("*Please Enter Confirm Password");
      hasError = true;
    } else if (newPassword !== confirmPassword) {
      setConfirmPasswordError("*Password Not Matched");
      hasError = true;
    }

    if (hasError) return;

    let credential = {
      email,
      newPassword,
      confirmPassword,
    };

    let apiData = await passwordChangeApi(credential);

    if (apiData?.data?.statusCode === 400 || apiData?.data?.success === false) {
      setConfirmPasswordError(apiData.data.message || "*Password change failed.");
    } else {
      sessionStorage.removeItem("resetToken");
      sessionStorage.removeItem("isVerified");
      navigate("/");
    }
  };

  const handleNewPasswordVisibility = () => {
    setShowNewPassword(!showNewPassword);
  };

  const handleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  var newVisibleIcon =
    showNewPassword === true ? { color: "#8B8B8B" } : { color: "#CBCBCB" };
  var confirmVisibleIcon =
    showConfirmPassword === true ? { color: "#8B8B8B" } : { color: "#CBCBCB" };

  var newPasswordVisible = newPassword.length < 1 ? LockIcon : null;
  var confirmPasswordVisible = confirmPassword.length < 1 ? LockIcon : null;

  return (
    <Grid container component="main" sx={{ height: "100vh" }}>
      <LeftSideImage />
      <Grid item xs={12} sm={12} md={12} lg={5}>
        <img src={LayoutLogo} alt="Layout" style={{ float: "right" }} />
        <Grid container direction="column" alignItems="center" rowSpacing={3}>
          <Grid item>
            <Grid
              container
              direction={"column"}
              alignItems="center"
              rowSpacing={2}
            >
              <Grid item>
                <img src={AppLogo} alt="AppLogo" />
              </Grid>
              <Grid item>
                <Typography component={"span"} variant={"body2"}>
                  <p className="topFont">Change Password</p>
                </Typography>
              </Grid>
            </Grid>
          </Grid>

          <Grid item>
            <form onSubmit={handleSubmit}>
              <Grid
                container
                direction={"column"}
                rowGap={3}
              >
                <Grid item>
                  <label className="lableText">New Password<span style={{ color: "red" }}>*</span></label>
                  <PasswordArea
                    id={"newPassword"}
                    show={showNewPassword}
                    password={newPassword}
                    handlePasswordChange={handleNewPasswordChange}
                    error={Boolean(newPasswordError)}
                    helperText={newPasswordError}
                    onClick={handleNewPasswordVisibility}
                    styleColor={newVisibleIcon}
                    passwordVisible={newPasswordVisible}
                  />
                </Grid>
                <Grid item>
                  <label className="lableText">Confirm Password<span style={{ color: "red" }}>*</span></label>
                  <PasswordArea
                    id={"confirmPassword"}
                    show={showConfirmPassword}
                    password={confirmPassword}
                    handlePasswordChange={handleConfirmPasswordChange}
                    error={Boolean(confirmPasswordError)}
                    helperText={confirmPasswordError}
                    onClick={handleConfirmPasswordVisibility}
                    styleColor={confirmVisibleIcon}
                    passwordVisible={confirmPasswordVisible}
                  />
                </Grid>
                <Grid item>
                  <StyledSubmitButton type="submit" fullWidth>
                    Change password
                  </StyledSubmitButton>
                </Grid>
              </Grid>
            </form>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}
